import { useState } from "react";

// custom hook to open and close modal and return isOpen and handleModalToggle
const useModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleModaltoggle = () => setIsOpen((prevState) => !prevState);

  return { isOpen, handleModaltoggle };
};

export default useModal;
